import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UserPassword } from "@user-management-context/write/domain/types/user";

export const updatePassword = createAsyncThunk<void, UserPassword, { extra: Partial<Dependencies> }>(
  "users/updatePassword",
  async (body: UserPassword, { extra: { publicRepository } }) => {
    return publicRepository!.updatePassword(body);
  },
);
